const fontSizes = {
  body: "16px",
};

export default fontSizes;
